import React from 'react'
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { sortBy, values } from 'lodash'

import { getText } from '../../lib/text'
import { getSuppliers } from '../../selectors'

// WARNING: duped in more files
const NO_SUPPLIER = "__NO_SUPPLIER__"
const WITH_SUPPLIER = "__WITH_SUPPLIER__"

type Props = {
  value: string, 
  onChange: (string => void), 
  
  label: ?string, 
  includeNegativeFilters: ?boolean, 

  // self-provided
  suppliersList: Object[], 
}

const SupplierPicker = ({ suppliersList, value, onChange, label, includeNegativeFilters }: Props) => {
  const control = (
    <FormControl 
      componentClass="select"
      bsSize="xsmall"
      value={value}
      onChange={evt => onChange(evt.target.value)}
      style={{ marginLeft: 10 }}
    >
      <option value={""} >{`${getText("Todos")}`}</option>
      { includeNegativeFilters && <option value={NO_SUPPLIER}>{`${getText("Sólo sin proveedor")}`}</option> }
      { includeNegativeFilters && <option value={WITH_SUPPLIER}>{`${getText("Sólo con proveedor")}`}</option> }
      <option disabled>{"──────────"}</option>
      { 
        suppliersList.map(s => (
          <option key={s._id} value={s._id}>{s.name}</option>
        ))
      }
    </FormControl>
  )
  
  return !label ? control : (
    <FormGroup>
      {label && <ControlLabel>{label}</ControlLabel>}
      {control}
    </FormGroup>
  )
}

const getSuppliersList = createSelector(
  [getSuppliers], 
  S => sortBy(values(S), o => o.name && o.name.toLowerCase()) 
)

const mapStateToProps = state => ({
  suppliersList: getSuppliersList(state), 
})

export default connect(mapStateToProps)(SupplierPicker)
